<!--
    我的课程-创建上课
    功能：上课前准备：上课时间、选择上课班级
    说明：旧版本与3.0版本都使用
-->
<template>
  <div class="myCreate" v-loading="loading">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item label="上课形式：">
        <el-radio-group v-model="formData.type">
          <!-- <el-radio v-if="hideType !== 1" :label="1">互动直播课</el-radio> -->
          <el-radio v-if="hideType !== 3" :label="3">线下互动课</el-radio>
        </el-radio-group>
      </el-form-item>

<!--      <el-form-item label="课件内容：">-->
<!--        <el-radio v-model="formKeti" :label="0">视频交互课</el-radio>-->
<!--      </el-form-item>-->

      <el-form-item label="课题：" v-if="formData.type == 1">
        <el-input v-model="formData.name" placeholder="请输入课题"></el-input>
      </el-form-item>

      <el-form-item label="授课老师：">
        <el-select v-model="formData.teacher_id" disabled>
          <el-option :label="formTeacher.name" :value="formTeacher.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="授课班型：" v-if="formData.type == 1">
        <el-radio v-model="formData.video_type" :label="2">1v4</el-radio>
      </el-form-item>

      <el-form-item label="上课时间：">
        <el-date-picker
          v-model="formData.start_time"
          type="datetime"
          :clearable="false"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="选择上课班级：">
        <div class="class-list">
          <ul>
            <li v-for="(itm, index) in formClasses" :key="itm.id">
              <h4>{{itm.name}}</h4>
              <p>班级码：{{itm.number}}</p>
              <p>教师：{{itm.teacher && itm.teacher.name ? itm.teacher.name : '--'}}</p>
              <p>学生数：{{itm.student_count || 0}}</p>

              <a class="class-close flex ac jc" @click="removeClasses(index)">
                <i class="el-icon-close"/>
              </a>
            </li>
          </ul>
          <div class="class-add flex ac jc" @click="classAdd">
            <i class="el-icon-plus" style="margin-right: 5px;"></i>
            班级
          </div>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="onSubmit">创建</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="提示"
      :visible.sync="dialogTip.show"
      width="500px">
      <el-row v-html="dialogTip.content" style="padding-bottom: 20px;line-height: 20px;"></el-row>

      <div class="flex jc">
        <el-button type="primary" @click="dialogTip.show = false">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import '../../../assets/reset.scss';
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/views/MyClass/MyCreate/index.vue